import React from "react";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";

const DynamicTextField = ({
  name,
  placeholder,
  register,
  validationRules = {},
  errors,
  watch,
  reset,
  sx = {},
  style = {},
  control,
  handleChange,
}) => {
  return (
    <Controller
      control={control}
      rules={validationRules}
      name={name}
      render={({ field: { onChange, onBlur, value } }) => (
        <TextField
          sx={{
            input: {
              fontSize: "14px",
              fontFamily: "var(--font-family-reg)",
            },
            ...sx,
          }}
          InputProps={{
            disableUnderline: false,
            disableInjectingGlobalStyles: true,
          }}
          InputLabelProps={{
            disableAnimation: true,
            disableInjectingGlobalStyles: true,
          }}
          size="small"
          variant="standard"
          style={{
            width: "100%",
            paddingTop: "3px",
            borderBottom: "1px solid lightgray",
            ...style,
          }}
          placeholder={placeholder}
          error={Boolean(errors?.[name])}
          helperText={errors?.[name]?.message}
          value={watch(name)}
          onChange={(e) => {
            const newValue = e.target.value;
            onChange(newValue);
            // console.log("e.target.name: ", e.target.name);

            if (handleChange) {
              handleChange(name, newValue);
            }
          }}
        />
      )}
    />
  );
};

export default DynamicTextField;
